import React from 'react';
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import { pltw } from './images';

import { ElementaryButton, Elementary2Button, HighSchoolButton, MiddleSchoolButton } from './navButtons';
import {makeStyles} from "@material-ui/core";
import Menu from "@material-ui/core/Menu/Menu";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Divider from "@material-ui/core/Divider/Divider";
import MenuIcon from '@material-ui/icons/Menu';

import './styles/pltwNavBar-styles.scss';
import IconButton from "@material-ui/core/IconButton/IconButton";
import {withRouter} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // marginBottom: '10px'
  },
  appBar: {
    backgroundColor: '#ffffff',
    border: '2px solid black'
  },
  title: {
    flexGrow: 1,
    color: '#F6EDD6',
    marginLeft: '20px',
    alignSelf: 'center',
  },
  logo: {
    height: '50px',
    cursor: 'pointer'
  },
  zeroWasteLogo: {
    maxHeight: '50px',
    maxWidth: '50vw'
  },
  sectionDesktop: {
    flexGrow: 1,
    display: 'none',
    textAlign: 'left',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    flexGrow: 1,
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  iconButton: {
    color: '#283f60',
  },
  elementary: {
    // width: '100px',
    fontSize: '16px',
    backgroundColor: '#f2642f',
    '&:hover': {
      backgroundColor: '#f15728'
    }
  },

  elementary2: {
    fontSize: '16px',
    backgroundColor: '#f8c12c',
    '&:hover': {
      backgroundColor: '#dda218'
    }
  },
  middleSchool: {
    fontSize: '16px',
    backgroundColor: '#99d6ce',
    '&:hover': {
      backgroundColor: '#7bbfb6'
    }
  },
  highSchool: {
    fontSize: '16px',
    backgroundColor: '#28b45f',
    '&:hover': {
      backgroundColor: '#0c984b'
    }
  }

}));

const PltwNavBar = ({ history }) => {
  const classes = useStyles();

  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleMobileMenuOpen = e => {
    setMobileMoreAnchorEl(e.currentTarget);
  };

  const handleMenuSelect = grade => {
    handleMobileMenuClose();
    history.push(`/home/${grade}`);
  };

  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const mobileMenuId = 'primary-search-account-menu-mobile';

  const mobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={() => handleMenuSelect(1)} className={classes.elementary}>K - 2</MenuItem>
      <Divider />
      <MenuItem onClick={() => handleMenuSelect(2)} className={classes.elementary2}>3 - 5</MenuItem>
      <Divider />
      <MenuItem onClick={() => handleMenuSelect(3)} className={classes.middleSchool}>6 - 8</MenuItem>
      <Divider />
      <MenuItem onClick={() => handleMenuSelect(4)} className={classes.highSchool}>9 - 12</MenuItem>
    </Menu>
  );

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} position="static">
        <Toolbar>

          <div className={classes.sectionMobile}>
            <img src={pltw} className={classes.logo} alt='pltw logo' onClick={() => history.push('/welcome')} />
            <div className={classes.title} />

            <IconButton
              className={classes.iconButton}
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
            >
              {/*<MoreIcon className={classes.iconButton} />*/}
              <MenuIcon />
            </IconButton>
          </div>

          <div className={classes.sectionDesktop}>
            <img src={pltw} className={classes.logo} alt='pltw logo' onClick={() => history.push('/welcome')} />
            <div className={classes.title} />
            <div className='navButtons'>
              <ElementaryButton />
              <Elementary2Button />
              <MiddleSchoolButton />
              <HighSchoolButton />
            </div>
          </div>
        </Toolbar>
      </AppBar>
      {mobileMenu}
    </div>
  );
};

export default withRouter(PltwNavBar);
